// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPolicy_page__pRjQv","frame":"PrivacyPolicy_frame__5iuJO","toolbar":"PrivacyPolicy_toolbar__UK3Id","back":"PrivacyPolicy_back__t7i7a"};